<template>
  <div
    class="drawshipcount"
    :title="showInfo.textTitle"
    :style="{ bottom: isMobile ? '30px' : '68px' }"
  >
    {{ getText }}
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, ref } from 'vue'
import { useUtilsHooks } from '@map-sdk/hooks'
import { MyMap } from '@map-sdk/sdk'
export default defineComponent({
  name: 'BaseDrawshipcount',
  props: {
    showInfo: {
      type: Object,
      default: () => ({
        isMobile: false,
        textTitle: '',
        text: '2级-0艘',
      }),
    },
    map: {
      type: MyMap,
      required: true,
    },
  },
  setup(props) {
    const zoomValue = ref<string>(`${props.map.getZoom()}级 - 0艘`)
    const { isMobile } = useUtilsHooks()
    props.map.on('zoomend', () => {
      zoomValue.value = props.showInfo.text || `${props.map.getZoom()}级 - 0艘`
    })
    const getText = computed(() => props.showInfo.text || zoomValue.value)

    return {
      isMobile,
      getText,
    }
  },
})
</script>
